// extracted by mini-css-extract-plugin
export default {"itemflows":"ItemFlowsModal_itemflows__jM+D2"};